import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-qr',
  templateUrl: './show-qr.component.html',
  styleUrls: ['./show-qr.component.scss']
})
export class ShowQrComponent{

  qrLink = sessionStorage.getItem('GCQrCode')

  constructor(public dialogRef: MatDialogRef<ShowQrComponent>,
    @Inject(MAT_DIALOG_DATA) public data :any) {}

  close(){
    this.dialogRef.close();
  }

}
